export default "__VITE_ASSET__BBwW_Tmp__"